export default {
  methods: {
    isBlank (value) {
      if (value === '' || value === null || typeof value === 'undefined' ||
        (typeof value === 'object' && Object.keys(value).length === 0) ||
        (typeof value === 'string' && value.trim().length < 1)) {
        return true
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FieldValue.js